<template>
  <Modal v-model="printSkuBarcodeModal" :title="$t('key1000594')" width="500" :transfer="false"
    :mask-closable="false" @on-visible-change="printSkuBarcodeChange">
    <h2 class="mb20 ml22">{{ ymsSku }}</h2>
    <Form ref="printSkuBarcodeForm" :model="printSkuBarcodeForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row type="flex">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1000624')" prop="printNum">
            <InputNumber :max="quantity" :min="1" v-model.trim="printSkuBarcodeForm.printNum"
              :formatter="value => `${parseInt(value)}`" style="width: 200px;"></InputNumber>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="printSkuBarcodeModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="printSKUBarcodeBtn">{{ $t('key1000594') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'printSkuBarcodeModal',
  mixins: [Mixin],
  data() {
    return {
      printSkuBarcodeModal: false,
      printSkuBarcodeForm: {
        printNum: null
      },
      ymsSku: null,
      quantity: null,
      ruleValidate: {
        printNum: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006925'), trigger: 'change'}
        ]
      },
    };
  },
  methods: {
    // 初始化数据
    initPrintSkuBarcodeData(obj) {
      this.printSkuBarcodeModal = true;
      this.ymsSku = obj._productInfo.ymsSku;
      this.quantity = obj.quantity;
    },
    // 打印条码
    printSKUBarcodeBtn() {
      let v = this;
      let path = v.$route.path;
      let url = '';
      switch (path) {
        case '/stockOrderDetails':
          url = api.post_packageInfo_appendYmsSkuExpressBillStcok;
          break;
      }
      let query = {
        quantity: v.printSkuBarcodeForm.printNum,
        sku: v.ymsSku,
        type: 2, // 打印类型 1 首次打印  2 批量打印
        printType: 1, // （打印尺寸类型 1：6*3 、2：7*2）
      };
      v.$refs['printSkuBarcodeForm'].validate((valid) => {
        if (valid) {
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              if (data) {
                let filenodeFullUrl = data.filenodeFullUrl || '';
                if (filenodeFullUrl) {
                  v.commonPrint(filenodeFullUrl, v.ymsSku, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004882')).then(() => {
                    v.printSkuBarcodeModal = false;
                  });
                } else {
                  v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006871'));
                  return false;
                }
              }
            }
          });
        }
      });
    },
    // 监听弹窗
    printSkuBarcodeChange(value) {
      if (!value) {
        this.ymsSku = null;
        this.$refs['printSkuBarcodeForm'].resetFields();
      }
    }
  }
};
</script>

<style lang="less">

</style>
